var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAbrasionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_120",
    "data-name": "Group 120",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_138",
    "data-name": "Rectangle 138",
    width: 140,
    height: 140,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_119",
    "data-name": "Group 119",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    d: "M70,0A70,70,0,1,1,0,70,70,70,0,0,1,70,0",
    fill: "#1a1818",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    d: "M61.913,52.11a23.525,23.525,0,0,0,1.379,9.358c.275.833.606,1.333.8,2.158a31.469,31.469,0,0,0-2.916,2.84l-2.955,2.957c-2.1,2.1-13.543,13.349-14.616,14.787A8.794,8.794,0,0,0,46.77,97.141a8.944,8.944,0,0,0,8.858-.587c1.642-1.2,15.025-14.828,17.833-17.638a32.786,32.786,0,0,0,2.917-3,16.185,16.185,0,0,1,2.043.755A24.943,24.943,0,0,0,101.4,73.408c1.929-1.456,2.821-1.773,2.821-3.868a2.5,2.5,0,0,0-4.249-1.451,20.554,20.554,0,0,1-13.014,5.03A20.134,20.134,0,0,1,77.2,70.581c-3.168-1.783-7.019-5.524-8.426-9a22.431,22.431,0,0,1-1.669-5.8,19.568,19.568,0,0,1,2.533-12.59c1.35-2.43,3-3.444,3-4.932a2.575,2.575,0,0,0-4.623-1.514c-3.51,4.173-6.108,9.74-6.108,15.364",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    d: "M70.623,52.266c0,3.156.146,5.07,1.553,7.939,2.521,5.143,8.064,9.179,13.689,9.179,3.154,0,5.069-.147,7.935-1.554,5.14-2.522,9.174-8.069,9.174-13.7,0-3.155-.146-5.071-1.554-7.939-2.521-5.143-8.064-9.18-13.688-9.18-3.13,0-5.113.137-7.934,1.556-5.146,2.59-9.175,8-9.175,13.7m16.175,8.4a9.561,9.561,0,0,1-2.936-.641,7.644,7.644,0,0,1-3.8-3.666,7.483,7.483,0,0,1,3.578-9.9,7.39,7.39,0,0,1,6.21-.044c5.511,2.2,6.058,10.951,0,13.571a9.592,9.592,0,0,1-3.048.685",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    "data-name": "Path 181",
    d: "M42.472,60.2a2.506,2.506,0,0,0,2.251,2.561c1.634.168,1.979-.867,2.882-1.47,1.262.846,6.8,7.208,7.777,7.47l5.326-5.253-7.7-7.626c.545-.8,1.594-1.345,1.594-2.683a2.6,2.6,0,0,0-2.179-2.491c-1.955,0-1.857.38-3.46,1.984L44.3,57.363c-.765.764-1.827,1.4-1.827,2.839",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_182",
    "data-name": "Path 182",
    d: "M35.784,100.2c0,2.61,1.436,4.046,4.044,4.046,1.758,0,3.412-2.091,4.782-3.461.466-.467,1.1-.845,1.283-1.518-1.693-.395-4.714-3.342-5.132-5.137-.633.17-2.275,2.045-2.839,2.608-.856.856-2.138,1.848-2.138,3.462",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_183",
    "data-name": "Path 183",
    d: "M83.066,52.888a3.747,3.747,0,1,0,7.466,0c0-1.9-1.636-3.424-4.044-3.424a3.62,3.62,0,0,0-3.422,3.424",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbrasionIcon);
export default __webpack_public_path__ + "static/media/abrasion-icon.9b4527dd03be4017a1b4864168fab340.svg";
export { ForwardRef as ReactComponent };